export default __webpack_public_path__ + "static/media/photo--sm--daniel-3.fe3fa2e2.jpg";